export default class EngineWidgetFormModifier {
    constructor(engineWidget) {
        this._engineWidget = engineWidget;
        this._form = null;
        this._params = null;
    }

    getPreparedForm(form, params) {
        this._form = form;
        this._params = params;
        this._setWidgetIndex();

        this._form.removeAttribute('id');
        this._preventDuplicateSelectors();
        this._setCalendarRange();
        this._setDestinationChoices();
        this._setPromotionalCode();
        this._setPromoCode();
        this._setSelectedRoom();
        return this._form;
    }

    static _isSet(value) { return ![undefined, ''].includes(value); }

    _preventDuplicateSelectors() {
        ['id', 'for'].forEach((attribute) => {
            this._form.querySelectorAll(`[${attribute}]`).forEach((element) => {
                const previousValue = element.getAttribute(attribute);
                if (attribute === 'id' && previousValue === 'roicalendar-translations') {
                    return;
                }
                element.setAttribute(
                    attribute,
                    `${previousValue}-widget-${this._form.dataset.roiEngineWidgetIndex}`
                );
            });
        });
    }

    _setCalendarRange() {
        const calendarTriggerButton = this._form.querySelector('.js-roicalendar-trigger');
        if (this.constructor._isSet(this._params.minDate)) {
            calendarTriggerButton.dataset.roicalendarMinDate = this._params.minDate;
            this._form.querySelector('.js-roicalendar-checkin').dataset.roicalendarInitialDate = this._params.minDate;
        }
        if (this.constructor._isSet(this._params.maxDate)) {
            calendarTriggerButton.dataset.roicalendarMaxDate = this._params.maxDate;
            this._form.querySelector('.js-roicalendar-checkout').dataset.roicalendarInitialDate = this._params.maxDate;
        }
    }

    _setDestinationChoices() {
        if (this.constructor._isSet(this._params.hotelCode)) {
            const hotelCodeField = this._form.querySelector(this._engineWidget._destinationCodeSelector);
            if (hotelCodeField === null) { // Individual website
                return;
            }
            if (!this.constructor._isSet(this._params.hotelName)) {
                throw Error('The hotel code is given but the hotel name is not');
            }
            hotelCodeField.value = this._params.hotelCode;
            this._setDestinationName();
        } else if (this.constructor._isSet(this._params.availableHotels)) {
            this._setDestinationSelectableChoices();
        }
    }

    _setDestinationName() {
        const hotelNameField = this._engineWidget.getHotelNameField(this._form);
        if (hotelNameField === null) {
            return;
        }
        const input = document.createElement('input');
        input.type = 'text';
        input.id = hotelNameField.id;
        input.value = this._params.hotelName;
        input.setAttribute('readonly', '');
        input.setAttribute('name', hotelNameField.getAttribute('name'));
        if (hotelNameField.tagName.toLowerCase() === 'select') {
            Array.from(hotelNameField.classList).forEach((className) => {
                input.classList.add(className.replace('select', 'input'));
            });
        } else {
            Array.from(hotelNameField.classList).forEach((className) => {
                if (!className.startsWith('js-')) {
                    input.classList.add(className.replace('select', 'input'));
                }
            });
        }
        hotelNameField.parentNode.replaceChild(input, hotelNameField);
    }

    _setDestinationSelectableChoices() {
        const hotelNameField = this._engineWidget.getHotelNameField(this._form),
            choices = this._params.availableHotels.split(',');
        if (hotelNameField.tagName.toLowerCase() === 'select') {
            const { options } = hotelNameField;
            for (let i = 0; i < options.length; i++) {
                if (!choices.includes(options[i].dataset.value)) {
                    options[i].classList.add('roi-hidden');
                }
            }
        } else if (this._form.querySelector('[data-destinations]')) {
            const container = this._form.querySelector('[data-destinations]');
            let options = JSON.parse(container.dataset.destinations);
            options.forEach((destination) => {
                destination.hotels = destination.hotels.filter(hotel => choices.includes(hotel[0]));
            });
            options = options.filter(destination => destination.hotels.length > 0);
            container.dataset.destinations = JSON.stringify(options);
        }
    }

    _setSelectedRoom() {
        if (this.constructor._isSet(this._params.roomCode)) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'priority_room';
            input.value = this._params.roomCode;
            this._form.appendChild(input);
        }
    }

    _setPromotionalCode() {
        if (this.constructor._isSet(this._params.offerCode)) {
            const action = this._form.getAttribute('action'),
                separator = action.includes('?') ? '&' : '?';
            this._form.setAttribute('action', `${action}${separator}co=${this._params.offerCode}`);
        }
    }

    _setPromoCode() {
        if (this.constructor._isSet(this._params.codpromo)) {
            this._form.querySelector("input[name='codpromo']").setAttribute('value', this._params.codpromo);
        }
    }

    _setWidgetIndex() {
        const maxAttempts = 50;
        let index = -1,
            widgetByIndex = null;
        do {
            widgetByIndex = document.querySelector(`[data-roi-engine-widget-index='${++index}']`);
        } while (widgetByIndex !== null && index <= maxAttempts);
        if (index === maxAttempts) {
            throw Error(`${maxAttempts} engine widgets already exist`);
        }
        this._form.dataset.roiEngineWidgetIndex = index.toString();
    }
}
